import action from '../../../abstract/action.js';

export default action({
  label: 'Edytuj',
  icon: 'EditIcon',
  main: ({ item }) => item.zusdeclarationspackages === null || item.zusdeclarationspackages.status !== 'Przesyłka przyjęta do ZUS',
  handle: async ({ $router, item: { id } }) => await $router.push({ name: 'zus-declarations-edit', params: { id } }),
  disabled: (item) => isDisabled(item),
  tooltip: {
    isActive: (item) => isDisabled(item),
    text: 'Nie można edytować deklaracji przypisanej do zestawu lub wysłanej do urzędu',
  },
});

function isDisabled(item) {
  if (item?.zusdeclarationspackages?.sent_at === null) {
    return false;
  }

  return item?.zusdeclarationspackages?.status === 'Przesyłka przyjęta do ZUS' ||
    item?.zusdeclarationspackages?.status === 'Przesyłka przyjęta do kontroli' ||
    (item?.zusdeclarationspackages?.status === null && item?.zusdeclarationspackages?.sent_at !== null);
}
